import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user/user.js";
import product from "./modules/products/product.js";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "vuex",
  storage: window.localStorage
});

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    user,
    product
  },
  plugins: [vuexLocalStorage.plugin]
});

export default store;
